import { Flex, Skeleton } from '@iheartjane/reefer';

export const AddToCartSkeleton = () => (
  <Skeleton animate>
    <Flex justifyContent="space-between">
      <Skeleton.Bone height={48} width={98} />
      <Skeleton.Bone height={48} width={273} />
    </Flex>
  </Skeleton>
);
